<div class="content">
  <iframe *ngIf="!isError" class="external-login-frame" #loginIframe [src]="ExternalLoginSrc"></iframe>
  <div *ngIf="isError" class="error-wrapper">
    <app-information-box [text1]="errorText1" [text2]="errorText2" [contactInfo]="contactInfoData" [icon]="'pp-icon-error'"></app-information-box>
    <cp-button class="primary-button call-to-action" captionToTranslate="BackToLogin.Login.PP" (onClick)="resetError()"></cp-button>
  </div>
</div>
